import type { RequestPortfolioArgsLike } from "./resolveRequestPortfolioLabels";
import { resolveRequestPortfolioLabels } from "./resolveRequestPortfolioLabels";

export type { RequestPortfolioArgsLike };

type RequestPortfolioResultAction =
  "screenshot_recognized" | "pdf_recognized" | "skipped" | "connect_plaid";

export interface RequestPortfolioResultDisplay {
  action: RequestPortfolioResultAction;
  title: string;
  body: string;
}

const resolveRequestPortfolioActionLabel = (
  action: any,
  args?: RequestPortfolioArgsLike,
): string => {
  const labels = resolveRequestPortfolioLabels(args);

  switch (action) {
    case "screenshot_recognized":
      return labels.snapPhotoLabel;
    case "pdf_recognized":
      return labels.uploadStatementLabel;
    case "skipped":
      return labels.skipLabel;
    case "connect_plaid":
      return labels.connectLabel;
    default:
      return "";
  }
};

/**
 * 解析 request_portfolio 的 result / role:tool content。
 * 支持 JSON 字符串或对象；action 映射为查看态正文文案。
 */
export const parseRequestPortfolioResult = (
  result: unknown,
  args?: RequestPortfolioArgsLike,
): RequestPortfolioResultDisplay | undefined => {
  if (result == null || result === "") {
    return undefined;
  }

  let parsed: unknown = result;
  if (typeof result === "string") {
    try {
      parsed = JSON.parse(result);
    } catch {
      return undefined;
    }
  }

  if (!parsed || typeof parsed !== "object") {
    return undefined;
  }

  const candidate = parsed as Record<string, unknown>;

  const action: any = candidate.action;
  const labels = resolveRequestPortfolioLabels(args);
  const fromResult =
    typeof candidate.title === "string" ? candidate.title.trim() : "";
  const title = fromResult || labels.title;
  const body =
    resolveRequestPortfolioActionLabel(action, args) ||
    (candidate?.content as any)?.trim() ||
    "";

  return { action, title, body };
};

export const hasRequestPortfolioResult = (result: unknown): boolean =>
  parseRequestPortfolioResult(result) != null;
